import React from 'react';
import '../template-file-css/document-file-template.css'; 


export const ROC_ProfessionalDevelopment = ({
    itemsRef,
    showErrorFor, 
}) => {

    return (
        <form id='ROC_ProfessionalDevelopment' className='file-pdf-document'>
            <div className='file-template'> 
            <p className='w-750'>
                    <h3>Competence and Service Based Assessment</h3>
                    <span className='small'>This evaluation will consist of a five-point competence scale:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>5 = FE (Far Exceeds)</td>
                        <td className='w-250'>4 = EX (Exceeds Expectations)</td>
                        <td className='w-250'>3 = ME (Neets Expectations)</td>
                    </tr>
                    <tr>
                        <td className='w-250'>2 = DR (Development Required) </td>
                        <td className='w-250'>1 = IR (Improvement Required)</td>
                    </tr>
                </table>
                <p className='w-750'>As an employee you must be skillful in the following areas of competence (credential scope of practice and service activities):</p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>General Service Activities </span> <span className='small'>(Licensed Staff Only)</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGeneralService_1' name='cbGeneralService_1' className='add-only' value='Counseling' />(a) Counseling and Therapy (Face-to-face encounter between a client, group of clients, client and family members, or family members and a behavioral health professional)</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGeneralService_2' name='cbGeneralService_2' className='add-only' value='Assessment' />(b) Assessment Activities (Diagnostic Evaluation, Psychosocial Assessment, and ASAM level of care)</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGeneralService_3' name='cbGeneralService_3' className='add-only' value='Medical' />(c) Medical Activities (Mental Status Examination)</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGeneralService_4' name='cbGeneralService_4' className='add-only' value='Understanding' />(d) An understanding of Scope of Practice based on current licensure</td>
                    </tr>


                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Psychosocial Rehabilitation Service Activities </span> <span className='small'>(Less than 3-years of experience)</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPsychosicalRehabilitation_1' name='cbPsychosicalRehabilitation_1' className='add-only' value='Rehabilitation' />(a) Restoration, rehabilitation and support of daily functioning to improve self- management of the negative effects of psychiatric or emotional symptoms that interfere with a person's daily functioning</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPsychosicalRehabilitation_2' name='cbPsychosicalRehabilitation_2' className='add-only' value='Restoration' />(b) Restoration and implementation of daily functioning and daily routines critical to remaining successfully in home, school, work, and community</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPsychosicalRehabilitation_3' name='cbPsychosicalRehabilitation_3' className='add-only' value='RehabilitationAnd' />(c) Rehabilitation and support to restore skills to function in a natural community environment</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>QBHS Basic Competencies (QMHS and/or CMS)</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbBasicCompetencies_1' name='cbBasicCompetencies_1' className='add-only' value='Mental' />(a) Mental illness or substance use disorder treatment and recovery</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbBasicCompetencies_2' name='cbBasicCompetencies_2' className='add-only' value='Therapeutically' />(b) How to therapeutically engage either with a person with mental illness or a person in substance is disorder treatment and recovery</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbBasicCompetencies_3' name='cbBasicCompetencies_3' className='add-only' value='Engage' />(c) How to therapeutically engage either with a person with mental illness or a person in substance is disorder treatment and recovery</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbBasicCompetencies_4' name='cbBasicCompetencies_4' className='add-only' value='Crisis' />(d) Crisis response procedures</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbBasicCompetencies_4' name='cbBasicCompetencies_4' className='add-only' value='SubstanceUse' />(e) Psychiatric and substance use disorder symptoms and their impact on functioning and behavior</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbBasicCompetencies_4' name='cbBasicCompetencies_4' className='add-only' value='Techniques' />(f) De-escalation techniques and an understanding of how the individual's own behavior can impact the behavior of others </td>
                    </tr>


                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Therapeutic Behavioral Service Activities</span><span className='small'>(Licensed staff; or non-licensed staff with either 3+ years of experience, or Bachelor or Master degree)</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbTherapeuticBehavioral_1' name='cbTherapeuticBehavioral_1' className='add-only' value='Identification' />(a) Identification of strategies or treatment options</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbTherapeuticBehavioral_2' name='cbTherapeuticBehavioral_2' className='add-only' value='Restoration' />(b) Restoration of social skills and daily functioning </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbTherapeuticBehavioral_3' name='cbTherapeuticBehavioral_3' className='add-only' value='TherapeuticallyEngage' />(c) How to therapeutically engage either with a person with mental illness or a person in substance is disorder treatment and recovery</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbTherapeuticBehavioral_4' name='cbTherapeuticBehavioral_4' className='add-only' value='Consultation' />(d) Consultation with licensed staff to assist with the individual's needs and service planning for individualized supports or care coordination of healthcare, behavioral healthcare, and non-healthcare services and development of a treatment plan</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbTherapeuticBehavioral_5' name='cbTherapeuticBehavioral_5' className='add-only' value='Interventions' />(e) Interventions using evidence-based techniques</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbTherapeuticBehavioral_6' name='cbTherapeuticBehavioral_6' className='add-only' value='Crisis' />(f) Crisis prevention and amelioration </td>
                    </tr>


                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Substance Use Disorder Case Management Activities </span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSubstanceUseDiscorder_1' name='cbSubstanceUseDiscorder_1' className='add-only' value='Providing' />(a) Providing training and facilitating linkages for the use of community resources; monitoring service delivery; obtaining or assisting individuals in obtaining necessary services</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSubstanceUseDiscorder_2' name='cbSubstanceUseDiscorder_2' className='add-only' value='AssistingIndividuals' />(b) Assisting individuals in increasing social support networks with family members, friends, and/or organizations; assisting individuals in performing daily living activities; and coordinating criminal justice services </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSubstanceUseDiscorder_3' name='cbSubstanceUseDiscorder_3' className='add-only' value='AssistingIndividuals' />(c) Assisting individuals in becoming involved with self-help support groups </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSubstanceUseDiscorder_4' name='cbSubstanceUseDiscorder_4' className='add-only' value='Coordinating' />(d) Coordinating: client assessments, treatment planning and crisis intervention services</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Community Psychiatric Supportive Treatment</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCommunityPsychiatricSupportiveTreatment_1' name='cbCommunityPsychiatricSupportiveTreatment_1' className='add-only' value='AnUnderstanding' />(a) An understanding of systems of care, such as natural support systems, entitlements and benefits, inter- and intra-agency systems of care, crisis response systems and their purpose, and the intent and activities of CPST.</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCommunityPsychiatricSupportiveTreatment_2' name='cbCommunityPsychiatricSupportiveTreatment_2' className='add-only' value='Characteristics' />(b) Characteristics of the population to be served, such as psychiatric symptoms, medications, culture, and age/gender development. </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCommunityPsychiatricSupportiveTreatment_3' name='cbCommunityPsychiatricSupportiveTreatment_3' className='add-only' value='Knowledge' />(c) Knowledge of CPST purpose, intent and activities. </td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>General Competency Based Assessment </span><span className='small'>(All Staff)</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGeneralCompetencyBasedAssessment_1' name='cbGeneralCompetencyBasedAssessment_1' className='add-only' value='Participating' /> (a) Participating Empowerment (Engage consumers into full participation pf skills building toward gaining independence)</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGeneralCompetencyBasedAssessment_2' name='cbGeneralCompetencyBasedAssessment_2' className='add-only' value='CommunityAndService' /> (b) Community and Service Networking (Access and connect with community resources and other services)</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGeneralCompetencyBasedAssessment_3' name='cbGeneralCompetencyBasedAssessment_3' className='add-only' value='CrisisPrevention' /> (c) Crisis Prevention and Intervention (Assess and de-escalate crisis situations)</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGeneralCompetencyBasedAssessment_4' name='cbGeneralCompetencyBasedAssessment_4' className='add-only' value='Advocacy' /> (d) Advocacy (Seek out resources and support consumer's needs)</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGeneralCompetencyBasedAssessment_5' name='cbGeneralCompetencyBasedAssessment_5' className='add-only' value='ImplementationOfPerson' /> (e) Implementation of Person-Centered Services (Effectively provide person centered services according to current standard)</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGeneralCompetencyBasedAssessment_6' name='cbGeneralCompetencyBasedAssessment_6' className='add-only' value='Documentation' /> (f) Documentation & Technical Knowledge (Documentation, Understanding Code of Ethics, Client Rights, HIPPA, Best Practices, etc.)</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGeneralCompetencyBasedAssessment_7' name='cbGeneralCompetencyBasedAssessment_7' className='add-only' value='Clinical' /> (g) Clinical Knowledge & Skills (Assess and provide therapeutic support services to diverse populations </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGeneralCompetencyBasedAssessment_8' name='cbGeneralCompetencyBasedAssessment_8' className='add-only' value='Interpersonal' /> (h) Interpersonal Skills (Establish and maintain a good rapport with individuals, families, and others) </td>
                    </tr>


                </table>
                <p className='w-750'><h3>Development Action Plan</h3> <br />
                    This Professional Development Plan will be reviewed every 90 to 180 days and renewed annually.
                </p>
                <p className='w-750'><h4>Development Action Plan - Goal 1</h4></p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Competency/Service of Focus:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtCompetencyService' name='txtCompetencyService' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Development Goal 1</span>
                            <span className='small'>What do you want to change? What will result from this change? What would success look like?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtWhatDoYouWantToChange' name='txtWhatDoYouWantToChange' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>I will improve my understanding of &nbsp;
                            <input type='text' id='txtIWillImproveMy' name='txtIWillImproveMy' className='add-only w-350 custom-add-only' />

                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>I will know that I have been successful when  &nbsp;
                            <input type='text' id='txtIWillKnowThatIHaveBeen' name='txtIWillKnowThatIHaveBeen' className='add-only w-350 custom-add-only' />

                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-300'>
                            <span className='eleHeader'>Tasks/Activities</span>
                            <span className='small'>
                                What specific tasks/activities will you do to help reach your goal?
                            </span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Target Dates</span>
                            <span className='small'>
                                When will you start/stop and complete each action? </span>
                        </td>
                        <td className='w-300'>
                            <span className='eleHeader'>Support Needed/Barriers to Overcome</span>
                            <span className='small'>
                                What help will you need and from whom? What barriers will you likely face?</span>
                        </td>
                    </tr>
                    <tr>

                        <td className='w-300'>
                            <input type='text' id='txtTasksActivities_1' name='txtTasksActivities_1' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtTasksActivities_2' name='txtTasksActivities_2' className='add-only' /></td>
                        <td className='w-300'>
                            <input type='text' id='txtTasksActivities_3' name='txtTasksActivities_3' className='add-only' /></td>
                    </tr>
                    <tr>

                        <td className='w-300'>
                            <input type='text' id='txtTasksActivities_4' name='txtTasksActivities_4' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtTasksActivities_5' name='txtTasksActivities_5' className='add-only' /></td>
                        <td className='w-300'>
                            <input type='text' id='txtTasksActivities_6' name='txtTasksActivities_6' className='add-only' /></td>
                    </tr>
                    <tr>

                        <td className='w-300'>
                            <input type='text' id='txtTasksActivities_7' name='txtTasksActivities_7' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtTasksActivities_8' name='txtTasksActivities_8' className='add-only' /></td>
                        <td className='w-300'>
                            <input type='text' id='txtTasksActivities_9' name='txtTasksActivities_9' className='add-only' /></td>

                    </tr>
                    <tr>

                        <td className='w-300'>
                            <input type='text' id='txtTasksActivities_10' name='txtTasksActivities_10' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtTasksActivities_11' name='txtTasksActivities_11' className='add-only' /></td>
                        <td className='w-300'>
                            <input type='text' id='txtTasksActivities_12' name='txtTasksActivities_12' className='add-only' /></td>

                    </tr>
                    <tr>

                        <td className='w-300'>
                            <input type='text' id='txtTasksActivities_10' name='txtTasksActivities_10' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtTasksActivities_11' name='txtTasksActivities_11' className='add-only' /></td>
                        <td className='w-300'>
                            <input type='text' id='txtTasksActivities_12' name='txtTasksActivities_12' className='add-only' /></td>

                    </tr>
                </table>
                <p className='w-750'><h3>Review your progress with your supervisor annually</h3></p>

                <table>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>Update</span></td>
                        <td className='w-300'><span className='eleHeader'>Progress toward goal</span></td>
                        <td className='w-150'><span className='eleHeader'>Your Initials & Date</span></td>
                        <td className='w-150'><span className='eleHeader'>Supervisor's Initials & date</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtUpdate_1' name='txtUpdate_1' placeholder='Update 1' className='add-only' /></td>
                        <td className='w-300'>
                            <input type='text' id='txtProgressToward_2' name='txtProgressToward_2' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtYourInitials_3' name='txtYourInitials_3' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtSupervisorInitials_4' name='txtSupervisorInitials_4' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtUpdate_5' name='txtUpdate_5' placeholder='Update 2' className='add-only' /></td>
                        <td className='w-300'>
                            <input type='text' id='txtProgressToward_6' name='txtProgressToward_6' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtYourInitials_7' name='txtYourInitials_7' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtSupervisorInitials_8' name='txtSupervisorInitials_8' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtUpdate_9' name='txtUpdate_9' placeholder='Update 3' className='add-only' /></td>
                        <td className='w-300'>
                            <input type='text' id='txtProgressToward_10' name='txtProgressToward_10' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtYourInitials_11' name='txtYourInitials_11' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtSupervisorInitials_12' name='txtSupervisorInitials_12' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtUpdate_13' name='txtUpdate_13' placeholder='Update 4' className='add-only' /></td>
                        <td className='w-300'>
                            <input type='text' id='txtProgressToward_14' name='txtProgressToward_14' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtYourInitials_15' name='txtYourInitials_15' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtSupervisorInitials_16' name='txtSupervisorInitials_16' className='add-only' /></td>

                    </tr>
                </table>

                <p className='w-750'><h4>Development Action Plan - Goal 2</h4></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Competency/Service of Focus:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtCompetencyService_1' name='txtCompetencyService_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Development Goal 2</span>
                            <span className='small'>What do you want to change? What will result from this change? What would success look like?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtWhatDoYouWantToChange_1' name='txtWhatDoYouWantToChange_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>I will improve my understanding of &nbsp;
                            <input type='text' id='txtIWillImproveMy_1' name='txtIWillImproveMy_1' className='add-only w-350 custom-add-only' />

                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>I will know that I have been successful when  &nbsp;
                            <input type='text' id='txtIWillKnowThatIHaveBeen_1' name='txtIWillKnowThatIHaveBeen_1' className='add-only w-350 custom-add-only' />

                        </td>
                    </tr>
                    
                </table>
                
                <table>
                    <tr>
                        <td className='w-300'>
                            <span className='eleHeader'>Tasks/Activities</span>
                            <span className='small'>
                                What specific tasks/activities will you do to help reach your goal?
                            </span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Target Dates</span>
                            <span className='small'>
                                When will you start/stop and complete each action? </span>
                        </td>
                        <td className='w-300'>
                            <span className='eleHeader'>Support Needed/Barriers to Overcome</span>
                            <span className='small'>
                                What help will you need and from whom? What barriers will you likely face?</span>
                        </td>
                    </tr>
                    <tr>

                        <td className='w-300'>
                            <input type='text' id='txtTasksActivities_13' name='txtTasksActivities_13' className='add-only'/></td>
                        <td className='w-150'>
                            <input type='date' id='txtTasksActivities_14' name='txtTasksActivities_14' className='add-only'/></td>
                        <td className='w-300'>
                            <input type='text' id='txtTasksActivities_15' name='txtTasksActivities_15' className='add-only'/></td>
                    </tr>
                    <tr>

                        <td className='w-300'>
                            <input type='text' id='txtTasksActivities_16' name='txtTasksActivities_16' className='add-only'/></td>
                        <td className='w-150'>
                            <input type='date' id='txtTasksActivities_17' name='txtTasksActivities_17' className='add-only'/></td>
                        <td className='w-300'>
                            <input type='text' id='txtTasksActivities_18' name='txtTasksActivities_18' className='add-only'/></td>
                    </tr>
                    <tr>

                        <td className='w-300'>
                            <input type='text' id='txtTasksActivities_19' name='txtTasksActivities_19' className='add-only'/></td>
                        <td className='w-150'>
                            <input type='date' id='txtTasksActivities_20' name='txtTasksActivities_20' className='add-only'/></td>
                        <td className='w-300'>
                            <input type='text' id='txtTasksActivities_21' name='txtTasksActivities_21' className='add-only'/></td>

                    </tr>
                    <tr>

                        <td className='w-300'>
                            <input type='text' id='txtTasksActivities_22' name='txtTasksActivities_22' className='add-only'/></td>
                        <td className='w-150'>
                            <input type='date' id='txtTasksActivities_23' name='txtTasksActivities_23' className='add-only'/></td>
                        <td className='w-300'>
                            <input type='text' id='txtTasksActivities_24' name='txtTasksActivities_24' className='add-only'/></td>

                    </tr>
                    <tr>

                        <td className='w-300'>
                            <input type='text' id='txtTasksActivities_25' name='txtTasksActivities_25' className='add-only'/></td>
                        <td className='w-150'>
                            <input type='date' id='txtTasksActivities_26' name='txtTasksActivities_26' className='add-only'/></td>
                        <td className='w-300'>
                            <input type='text' id='txtTasksActivities_27' name='txtTasksActivities_27' className='add-only'/></td>

                    </tr>
                </table>

                <p className='w-750'><h3>Review your progress with your supervisor every 90 - 180 days</h3></p>

                <table>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>Update</span></td>
                        <td className='w-300'><span className='eleHeader'>Progress toward goal</span></td>
                        <td className='w-150'><span className='eleHeader'>Your Initials & Date</span></td>
                        <td className='w-150'><span className='eleHeader'>Supervisor's Initials & date</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtUpdate_11' name='txtUpdate_11' placeholder='Update 1' className='add-only' /></td>
                        <td className='w-300'>
                            <input type='text' id='txtProgressToward_12' name='txtProgressToward_12' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtYourInitials_13' name='txtYourInitials_13' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtSupervisorInitials_14' name='txtSupervisorInitials_14' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtUpdate_15' name='txtUpdate_15' placeholder='Update 2' className='add-only' /></td>
                        <td className='w-300'>
                            <input type='text' id='txtProgressToward_16' name='txtProgressToward_16' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtYourInitials_17' name='txtYourInitials_17' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtSupervisorInitials_18' name='txtSupervisorInitials_18' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtUpdate_19' name='txtUpdate_19' placeholder='Update 3' className='add-only' /></td>
                        <td className='w-300'>
                            <input type='text' id='txtProgressToward_20' name='txtProgressToward_20' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtYourInitials_21' name='txtYourInitials_21' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtSupervisorInitials_22' name='txtSupervisorInitials_22' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtUpdate_23' name='txtUpdate_23' placeholder='Update 4' className='add-only' /></td>
                        <td className='w-300'>
                            <input type='text' id='txtProgressToward_24' name='txtProgressToward_24' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtYourInitials_25' name='txtYourInitials_25' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtSupervisorInitials_26' name='txtSupervisorInitials_26' className='add-only' /></td>

                    </tr>
                </table>

                <p className='w-750'><h4>Development Action Plan - Goal 3</h4></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Competency/Service of Focus:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtCompetencyService_2' name='txtCompetencyService_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Development Goal 3</span>
                            <span className='small'>What do you want to change? What will result from this change? What would success look like?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtWhatDoYouWantToChange_2' name='txtWhatDoYouWantToChange_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>I will improve my understanding of &nbsp;
                            <input type='text' id='txtIWillImproveMy_2' name='txtIWillImproveMy_2' className='add-only w-350 custom-add-only' />

                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>I will know that I have been successful when  &nbsp;
                            <input type='text' id='txtIWillKnowThatIHaveBeen_2' name='txtIWillKnowThatIHaveBeen_2' className='add-only w-350 custom-add-only' />

                        </td>
                    </tr>
                    
                </table>
                
                <table>
                    <tr>
                        <td className='w-300'>
                            <span className='eleHeader'>Tasks/Activities</span>
                            <span className='small'>
                                What specific tasks/activities will you do to help reach your goal?
                            </span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Target Dates</span>
                            <span className='small'>
                                When will you start/stop and complete each action? </span>
                        </td>
                        <td className='w-300'>
                            <span className='eleHeader'>Support Needed/Barriers to Overcome</span>
                            <span className='small'>
                                What help will you need and from whom? What barriers will you likely face?</span>
                        </td>
                    </tr>
                    <tr>

                        <td className='w-300'>
                            <input type='text' id='txtTasksActivities_28' name='txtTasksActivities_28' className='add-only'/></td>
                        <td className='w-150'>
                            <input type='date' id='txtTasksActivities_29' name='txtTasksActivities_29' className='add-only'/></td>
                        <td className='w-300'>
                            <input type='text' id='txtTasksActivities_30' name='txtTasksActivities_30' className='add-only'/></td>
                    </tr>
                    <tr>

                        <td className='w-300'>
                            <input type='text' id='txtTasksActivities_31' name='txtTasksActivities_31' className='add-only'/></td>
                        <td className='w-150'>
                            <input type='date' id='txtTasksActivities_32' name='txtTasksActivities_32' className='add-only'/></td>
                        <td className='w-300'>
                            <input type='text' id='txtTasksActivities_33' name='txtTasksActivities_33' className='add-only'/></td>
                    </tr>
                    <tr>

                        <td className='w-300'>
                            <input type='text' id='txtTasksActivities_34' name='txtTasksActivities_34' className='add-only'/></td>
                        <td className='w-150'>
                            <input type='date' id='txtTasksActivities_35' name='txtTasksActivities_35' className='add-only'/></td>
                        <td className='w-300'>
                            <input type='text' id='txtTasksActivities_36' name='txtTasksActivities_36' className='add-only'/></td>

                    </tr>
                    <tr>

                        <td className='w-300'>
                            <input type='text' id='txtTasksActivities_37' name='txtTasksActivities_37' className='add-only'/></td>
                        <td className='w-150'>
                            <input type='date' id='txtTasksActivities_38' name='txtTasksActivities_38' className='add-only'/></td>
                        <td className='w-300'>
                            <input type='text' id='txtTasksActivities_39' name='txtTasksActivities_39' className='add-only'/></td>

                    </tr>
                    <tr>

                        <td className='w-300'>
                            <input type='text' id='txtTasksActivities_40' name='txtTasksActivities_40' className='add-only'/></td>
                        <td className='w-150'>
                            <input type='date' id='txtTasksActivities_41' name='txtTasksActivities_41' className='add-only'/></td>
                        <td className='w-300'>
                            <input type='text' id='txtTasksActivities_42' name='txtTasksActivities_42' className='add-only'/></td>

                    </tr>
                </table>

                <p className='w-750'><h3>Review your progress with your supervisor every 90 - 180 days</h3></p>

                <table>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>Update</span></td>
                        <td className='w-300'><span className='eleHeader'>Progress toward goal</span></td>
                        <td className='w-150'><span className='eleHeader'>Your Initials & Date</span></td>
                        <td className='w-150'><span className='eleHeader'>Supervisor's Initials & date</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtUpdate_28' name='txtUpdate_28' placeholder='Update 1' className='add-only' /></td>
                        <td className='w-300'>
                            <input type='text' id='txtProgressToward_29' name='txtProgressToward_29' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtYourInitials_30' name='txtYourInitials_30' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtSupervisorInitials_31' name='txtSupervisorInitials_31' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtUpdate_32' name='txtUpdate_32' placeholder='Update 2' className='add-only' /></td>
                        <td className='w-300'>
                            <input type='text' id='txtProgressToward_33' name='txtProgressToward_33' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtYourInitials_34' name='txtYourInitials_34' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtSupervisorInitials_35' name='txtSupervisorInitials_35' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtUpdate_36' name='txtUpdate_36' placeholder='Update 3' className='add-only' /></td>
                        <td className='w-300'>
                            <input type='text' id='txtProgressToward_37' name='txtProgressToward_37' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtYourInitials_38' name='txtYourInitials_38' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtSupervisorInitials_39' name='txtSupervisorInitials_39' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtUpdate_40' name='txtUpdate_40' placeholder='Update 4' className='add-only' /></td>
                        <td className='w-300'>
                            <input type='text' id='txtProgressToward_41' name='txtProgressToward_41' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtYourInitials_42' name='txtYourInitials_42' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtSupervisorInitials_43' name='txtSupervisorInitials_43' className='add-only' /></td>

                    </tr>
                </table>
                <p className='w-750'><h4>Additional comments, trainings, or strategies:</h4></p>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Staff Signature </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Supervisor Signature </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table>



            </div>
        </form>

    )
}  

